
import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Radio, Row, Select, TimePicker, Upload } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { UploadOutlined, InboxOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { shouldComponentBeVisible } from '../../utils/evaluateCondition';
import globalGetPadding from '../../utils/getPadding';
import { getBorderRadiusValue } from '../../utils/borderRadius';
function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
        default:
            return undefined;
    }
}

const UploadPropsDefaults = {
    label: 'Upload your file',
    name: '',
    uploadLabel: 'Click to Upload',
    accept: '.png,.gif,.jpg,.jpeg,.pdf',
    acceptTipMessage: 'Allowed file types: ',
    acceptErrorMessage: 'File type not allowed.',
    maxSize: 5242880,
    maxSizeTipMessage: 'Max file size: ',
    maxSizeErrorMessage: 'File size exceeds limit.',
    maxCount: 1,
    required: false,
    visible: {
        alwaysShow: true,
        conditions: []
    },
    isFormItem: true,
    buttonWidth: 'auto',
    uploadType: 'click'
};
const { Dragger } = Upload;

const StyledUpload = styled(Upload)`
    .ant-upload-select {
        display: ${({$buttonWidth})=>($buttonWidth+' !important')};
    }
`;

const StyledDragger = styled(Dragger)`
    .ant-upload-drag {
        width: ${({$buttonWidth})=>($buttonWidth+' !important')};
        background-color: ${({$buttonBackColor})=>($buttonBackColor+' !important')};
        border-color: ${({$buttonBorderColor})=>($buttonBorderColor+' !important')};
        border-radius: ${({$buttonBorderRadius})=> {
            const value = getBorderRadiusValue($buttonBorderRadius);
            return value ? `${value} !important` : '';
        }};
        transition: all 0.2s;
    }
    .ant-upload-drag:hover {
        opacity: 0.6;
    }
`;

export const FormUpload = (_a)=> {
    const rootData = _a.form_data.root;
    const root_formStyle = rootData?.data?.formStyle;
    const root_formMessage = rootData?.data?.messageData;
    const isMobile = _a.formClientWidth <= 480;
    var _b, _c, _d, _e, _f, _bb, _cc, _dd, _ee, _ff, _bbb, _ccc;
    var style = _a.style;
    var wStyle = {
        backgroundColor: (_c = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _c !== void 0 ? _c : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.padding, isMobile),
        borderRadius: getBorderRadiusValue((_f = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _f !== void 0 ? _f : undefined),
    };
    var labelStyle = {
        color: (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : undefined,
        fontSize: (_d = style === null || style === void 0 ? void 0 : style?.fontSize) !== null && _d !== void 0 ? (isMobile ? _d/1.1 : _d) : undefined,
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_e = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _e !== void 0 ? _e : undefined,
    }
    var buttonStyle = {
        color: (_bb = style === null || style === void 0 ? void 0 : style.buttonFontColor) !== null && _bb !== void 0 ? _bb : undefined,
        backgroundColor: (_cc = style === null || style === void 0 ? void 0 : style.buttonBackColor) !== null && _cc !== void 0 ? _cc : undefined,
        fontSize: (_dd = style === null || style === void 0 ? void 0 : style?.buttonFontSize) !== null && _dd !== void 0 ? (isMobile ? _dd/1.1 : _dd) : undefined,
        borderColor: (_ee = style === null || style === void 0 ? void 0 : style.buttonBorderColor) !== null && _ee !== void 0 ? _ee : undefined,
        borderRadius: getBorderRadiusValue((_ff = style === null || style === void 0 ? void 0 : style.buttonBorderRadius) !== null && _ff !== void 0 ? _ff : undefined),
    }
    var tipStyle = {
        color: (_bbb = style === null || style === void 0 ? void 0 : style.tipFontColor) !== null && _bbb !== void 0 ? _bbb : undefined,
        fontSize: (_ccc = style === null || style === void 0 ? void 0 : style?.tipFontSize) !== null && _ccc !== void 0 ? (isMobile ? _ccc/1.1 : _ccc) : undefined,
    }
    // var text = (_g = props === null || props === void 0 ? void 0 : props.text) !== null && _g !== void 0 ? _g : TextPropsDefaults.text;
    // return <div style={wStyle}>
    //     {text}
    // </div>;

    var _g, _h, _i, _j, _k, _l, _m, _n, _o;
    var props = _a.props;
    var label = (_g = props === null || props === void 0 ? void 0 : props.label) !== null && _g !== void 0 ? _g : UploadPropsDefaults.label;
    var name = (_h = props === null || props === void 0 ? void 0 : props.name) !== null && _h !== void 0 ? _h : UploadPropsDefaults.name;
    var uploadLabel = (_i = props === null || props === void 0 ? void 0 : props.uploadLabel) !== null && _i !== void 0 ? _i : UploadPropsDefaults.uploadLabel;
    var accept = (_j = props === null || props === void 0 ? void 0 : props.accept) !== null && _j !== void 0 ? _j : UploadPropsDefaults.accept;
    var maxSize = (_l = props === null || props === void 0 ? void 0 : props.maxSize) !== null && _l !== void 0 ? _l : UploadPropsDefaults.maxSize;
    var maxCount = (_m = props === null || props === void 0 ? void 0 : props.maxCount) !== null && _m !== void 0 ? _m : UploadPropsDefaults.maxCount;
    var required = (_k = props === null || props === void 0 ? void 0 : props.required) !== null && _k !== void 0 ? _k : UploadPropsDefaults.required;
    var visible = (_n = props === null || props === void 0 ? void 0 : props.visible) !== null && _n !== void 0 ? _n : UploadPropsDefaults.visible;
    var uploadType = (_o = props === null || props === void 0 ? void 0 : props.uploadType) !== null && _o !== void 0 ? _o : UploadPropsDefaults.uploadType;

    const formStyle = _a.formStyle;
    const item_layout = !formStyle?.layout && root_formStyle?.layout ? root_formStyle?.layout : formStyle?.layout ? 
        formStyle?.layout : '';
    const item_colon = formStyle?.colon === undefined && root_formStyle?.colon !== undefined ? root_formStyle?.colon : formStyle?.colon;
    const requiredText = props?.requiredText !== null && props?.requiredText !== void 0 ? props?.requiredText : root_formMessage?.required;
    const acceptTipMessage = props?.acceptTipMessage !== null && props?.acceptTipMessage !== void 0 ? props?.acceptTipMessage : '';
    const acceptErrorMessage = props?.acceptErrorMessage !== null && props?.acceptErrorMessage !== void 0 ? props?.acceptErrorMessage : UploadPropsDefaults?.acceptErrorMessage;
    const maxSizeTipMessage = props?.maxSizeTipMessage !== null && props?.maxSizeTipMessage !== void 0 ? props?.maxSizeTipMessage : '';
    const maxSizeErrorMessage = props?.maxSizeErrorMessage !== null && props?.maxSizeErrorMessage !== void 0 ? props?.maxSizeErrorMessage : UploadPropsDefaults?.maxSizeErrorMessage;

    // const maxSize_mb = useMemo(()=>{
    //     if(maxSize < 1024) {
    //         return maxSize+'B'
    //     }
    //     else if(maxSize < 1024*1024) {
    //         return parseInt(maxSize / 1024) + 'KB'
    //     }
    //     else {
    //         return parseInt(maxSize / 1024 / 1024) + 'MB'
    //     }
    // }, [maxSize]);
    
    const [fileList, setFileList] = useState([]);
    const [base64List, setBase64List] = useState([]);

    const handleRemoveFile = useCallback((file)=>{
        const d_index = base64List.findIndex(data=>data.id === file.uid);
        if(d_index >= 0) {
            const newBase64List = base64List.slice();
            newBase64List.splice(d_index, 1);
            setBase64List(newBase64List);
            if(_a.formRef) {
                if(maxCount > 1) {
                    _a.formRef.setFieldValue(name, newBase64List?.length ? newBase64List?.map(item=>item.data) : undefined);
                    _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                        ...prevData,
                        [name]: {
                            value: newBase64List?.length ? newBase64List?.map(item=>item.data) : undefined,
                            isRequired: prevData[name]?.isRequired,
                            type: prevData[name]?.type
                        }
                    }))
                }
                else {
                    _a.formRef.setFieldValue(name, newBase64List?.length ? newBase64List[0].data : undefined);
                    _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                        ...prevData,
                        [name]: {
                            value: newBase64List?.length ? newBase64List[0].data : undefined,
                            isRequired: prevData[name]?.isRequired,
                            type: prevData[name]?.type
                        }
                    }))
                }
            }
        }
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        setFileList(newFileList);
    }, [_a, base64List, fileList, maxCount, name]);

    const handleBeforeUpload = useCallback((file)=>{
        const acceptArray = accept.split(',').map(item => item.substring(1));
        const isJpgOrPng = acceptArray.find(item=>file.type.includes(item));
        if (!isJpgOrPng) {
            _a.handleAlertError && _a.handleAlertError(acceptErrorMessage);
            return false;
        }
        const isLt2M = file.size <= maxSize;
        if (!isLt2M) {
            _a.handleAlertError && _a.handleAlertError(maxSizeErrorMessage);
            return false;
        }
        return isJpgOrPng && isLt2M;
    }, [_a, accept, acceptErrorMessage, maxSize, maxSizeErrorMessage]);

    const handleFormatFile = useCallback((option)=>{
        if(base64List?.length >= maxCount && maxCount > 1) {
            _a.handleAlertError && _a.handleAlertError(`最多只能上�?${maxCount} 个文件`);
            option.onError();
            if(_a.formRef) {
                if(maxCount > 1) {
                    _a.formRef.setFieldValue(name, base64List?.length ? base64List?.map(item=>item.data) : undefined);
                    _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                        ...prevData,
                        [name]: {
                            value: base64List?.length ? base64List?.map(item=>item.data) : undefined,
                            isRequired: prevData[name]?.isRequired,
                            type: prevData[name]?.type
                        }
                    }))
                }
                else {
                    _a.formRef.setFieldValue(name, base64List?.length ? base64List[0].data : undefined);
                    _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                        ...prevData,
                        [name]: {
                            value: base64List?.length ? base64List[0].data : undefined,
                            isRequired: prevData[name]?.isRequired,
                            type: prevData[name]?.type
                        }
                    }))
                }
            }
            return;
        }
        const formData = new FormData();
        formData.append("files[]", option.file);
        const reader = new FileReader();
        reader.readAsDataURL(option.file);
        reader.onloadend = function(e) {
            const newData = [
                ...base64List,
                {
                    id: option.file.uid,
                    data: e.target.result // 保存图片的base64
                }
            ]
            const newData2 = newData.length > maxCount ? newData.slice((0-maxCount)) : newData.slice();
            setBase64List(newData2)
            if(_a.formRef) {
                if(maxCount > 1) {
                    _a.formRef.setFieldValue(name, newData2?.length ? newData2?.map(item=>item.data) : undefined);
                    _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                        ...prevData,
                        [name]: {
                            value: newData2?.length ? newData2?.map(item=>item.data) : undefined,
                            isRequired: prevData[name]?.isRequired,
                            type: prevData[name]?.type
                        }
                    }))
                }
                else {
                    _a.formRef.setFieldValue(name, newData2?.length ? newData2[0].data : undefined);
                    _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                        ...prevData,
                        [name]: {
                            value: newData2?.length ? newData2[0].data : undefined,
                            isRequired: prevData[name]?.isRequired,
                            type: prevData[name]?.type
                        }
                    }))
                }
            }
            if (e && e.target && e.target.result) {
                option.onSuccess();
            }
        };
    }, [_a, base64List, maxCount, name])

    const handleOnChangeFile = useCallback((info)=>{
        setFileList(info.fileList);
    }, [])
            
    const calVisible = useMemo(()=>{
        if(visible?.alwaysShow) {
            return true;
        }
        else {
            return shouldComponentBeVisible(visible?.conditions, _a?.allFieldValues);
        }
    }, [visible, _a?.allFieldValues])

    useEffect(()=>{
        if(!calVisible && _a?.formRef) {
            _a?.formRef.setFieldValue(name, undefined);
            _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                ...prevData,
                [name]: {
                    value: undefined,
                    isRequired: prevData[name]?.isRequired,
                    type: prevData[name]?.type
                }
            }))
            setFileList([]);
            setBase64List([]);
        }
    }, [calVisible])

    return !calVisible ? null : <div style={wStyle}>
        <Form.Item
            label={label && label.trim() ? <span style={labelStyle}>{item_layout === 'vertical' && item_colon ? label+": " : label}</span> : undefined}
            name={name}
            className={(!formStyle?.labelAlign && root_formStyle?.labelAlign === 'right') || formStyle?.labelAlign === 'right' ? 
                'ant-form-item-label-right' : ''}
            layout={item_layout}
            colon={item_colon}
            rules={required ? [{ required: true, message: requiredText}] : []}
        >
            {
                uploadType === 'drag' ? <StyledDragger 
                    $buttonWidth={style?.buttonWidth === 'full' ? '100%' : 'fit-content'}
                    $buttonBackColor={buttonStyle?.backgroundColor}
                    $buttonBorderColor={buttonStyle?.borderColor}
                    $buttonBorderRadius={buttonStyle?.borderRadius}
                    maxCount={maxCount}
                    accept={accept}
                    onRemove={handleRemoveFile}
                    beforeUpload={handleBeforeUpload}
                    customRequest={handleFormatFile}
                    onChange={handleOnChangeFile}
                    fileList={fileList}
                >
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined style={{color: buttonStyle?.color}}/>
                    </p>

                    <p style={{
                        textAlign: 'center',
                        color: buttonStyle?.color,
                        fontSize: buttonStyle?.fontSize,
                    }}>{uploadLabel}</p>

                    <div style={tipStyle}>
                        {acceptTipMessage}
                        <br />
                        {maxSizeTipMessage}
                    </div>
                </StyledDragger> : <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px'
                    }}
                >
                    <StyledUpload
                        $buttonWidth={style?.buttonWidth === 'full' ? 'inline' : 'inline-block'}
                        maxCount={maxCount}
                        accept={accept}
                        onRemove={handleRemoveFile}
                        beforeUpload={handleBeforeUpload}
                        customRequest={handleFormatFile}
                        onChange={handleOnChangeFile}
                        fileList={fileList}
                    >
                        <div
                            style={{
                                border: '1px solid',
                                display: 'flex',
                                gap: '8px',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '4px 15px',
                                boxShadow: '0 2px 0 rgba(0, 0, 0, 0.02)',
                                cursor: 'pointer',
                                ...buttonStyle
                            }}
                        >
                            <UploadOutlined />
                            {uploadLabel}
                        </div>
                    </StyledUpload>
                    <div style={tipStyle}>
                        {acceptTipMessage}
                        <br />
                        {maxSizeTipMessage}
                    </div>
                </div>
            }
        </Form.Item>
    </div>;
}

